import {RNTagItemProps} from "shared/controls/RNTags/RNTagItem";

export class RNTagItemModel{
    public Item:RNTagItemProps;
    public Visible:boolean;
    constructor(Item:RNTagItemProps) {
        this.Item=Item;
        this.Visible=true;
    }

    public get Value(){
        return this.Item.Value;
    }

    public get Label(){
        return this.Item.Label;
    }
}